import { render, staticRenderFns } from "./UpdateBirthday.vue?vue&type=template&id=0502d712"
import script from "./UpdateBirthday.vue?vue&type=script&lang=js"
export * from "./UpdateBirthday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports